import React, { useEffect, useState } from 'react';
import { Form, Row, Col, notification, Modal, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { Loading } from 'components';
import { getSlotTemplates } from 'store/requests/routing';
import { STATUS } from 'helpers/constants';
import { generateSlotForZone } from 'store/requests/slot';

const { Option } = Select;
const GenerateSlot = ({ onCloseHandler, dataItem }) => {
  const [loading, setLoading] = useState(false);
  const [slotTemplates, setSlotTemplates] = useState([]);
  const [slotTemplateId, setSlotTemplateId] = useState(null);
  const [form] = Form.useForm();
  const { t } = useTranslation();

  useEffect(() => {
    async function loadData() {
      getSlotTemplates(`filter=active==true&size=2000`).then((res) => {
        setSlotTemplates(res.content);
      });
    }
    loadData();
  }, []);

  const notificationToast = (type, message, description) => {
    notification[type]({
      message,
      description,
    });
  };

  const onFinish = async (values) => {
    setLoading(true);
    if (!values.slotTemplateId) {
      return;
    }
    generateSlotForZone(dataItem.id, values.slotTemplateId)
      .then((data) => {
        setLoading(true);
        notificationToast(
          STATUS.SUCCESS,
          t('processCompleted'),
          t('slotsGenerated'),
        );
        onCloseHandler();
      })
      .catch((error) => {
        console.log(error, 'error');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal
      open={true}
      maskClosable={false}
      onOk={() => form.submit()}
      okText={t('generateSlot')}
      onCancel={onCloseHandler}
      okButtonProps={{ disabled: !slotTemplateId }}
      title={t('generateSlot')}
      width={600}
    >
      <div>
        {loading && (
          <Row justify="center" className="loading">
            <Col span={12}>
              <Loading />
            </Col>
          </Row>
        )}
        {!loading && (
          <Row>
            <Col span={24}>
              <Form
                labelCol={{ span: 10 }}
                wrapperCol={{ span: 24 }}
                name="basic"
                onFinish={onFinish}
                form={form}
              >
                <Row>
                  <Col span={24}>
                    <p>{`${dataItem.code} ${t('selectSlotTemplateForThisZone')}`}</p>
                    <Form.Item
                      name="slotTemplateId"
                      rules={[
                        {
                          required: true,
                          message: t('alert.fillField'),
                        },
                      ]}
                    >
                      <Select
                        className="fullWidth"
                        showSearch
                        placeholder={t('selectSlotTemplate')}
                        autoClearSearchValue={false}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.children ?? '')
                            .toLocaleLowerCase('tr-TR')
                            .includes(input.toLocaleLowerCase('tr-TR'))
                        }
                        onChange={(val) => setSlotTemplateId(val)}
                      >
                        {slotTemplates.map((slotTemplate, index) => (
                          <Option key={index} value={slotTemplate.id}>
                            {slotTemplate.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        )}
      </div>
    </Modal>
  );
};

export default GenerateSlot;
